import { DerivativeSearchValue } from '@zero/shared/util-models';
import { DerivativeType } from './derivative.type';

export const DERIVATIVE_TYPES: DerivativeType[] = ['knockout', 'optionsscheine', 'factor', 'discount'];
export const LEVERAGES = [5, 10, 15, 20];
export const CAPS: DerivativeSearchValue[] = [
  { lower: -10, upper: -5 },
  { lower: -5, upper: 0 },
  { lower: 0, upper: 5 },
  { lower: 5, upper: 10 },
  { lower: 10, upper: 20 },
  { lower: -100, upper: 100 },
];
export const STRIKES: DerivativeSearchValue[] = [
  { lower: -10, upper: -5 },
  { lower: -5, upper: 0 },
  { lower: 0, upper: 5 },
  { lower: 5, upper: 10 },
  { lower: 10, upper: 20 },
  { lower: -30, upper: 30 },
];
export const DURATIONS: DerivativeSearchValue[] = [
  { lower: 0, upper: 90 },
  { lower: 90, upper: 180 },
  { lower: 180, upper: 9999999 },
  { lower: 0, upper: 9999999 },
];
export const FACTORS: DerivativeSearchValue[] = [
  { lower: 2, upper: 2 },
  { lower: 3, upper: 3 },
  { lower: 4, upper: 4 },
  { lower: 5, upper: 5 },
  { lower: 6, upper: 6 },
  { lower: 6, upper: 100 },
];
